import { createSlice } from "@reduxjs/toolkit";
import {
  createUser,
  getUsers,
  updateUser,
} from "../../actions/users/userAction";
import { User } from "../../../types/users";

interface UserState {
  isLoading: boolean;
  isError: boolean;
  data: User[];
  count: number;
}

const initialState: UserState = {
  isLoading: false,
  isError: false,
  data: [],
  count: 0,
};

const userReducer = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUsers.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        const { users, count } = action.payload;
        state.data = users.map((user) => ({
          id: user.gpid,
          firstName: user.first_name,
          lastName: user.last_name,
          gpid: String(user.gpid),
          email: user.email,
          roles: user.userRoles.map((role) => role.role.name).join("\n"),
          sectors: user.userSectors
            .map((sector) => sector.sectors.name)
            .join("\n"),
          userRoles: user.userRoles.map((role) => ({
            displayText: role.role.name,
            id: role.role.id.toString(),
          })),
          userSectors: user.userSectors.map((sector) => ({
            displayText: sector.sectors.name,
            id: sector.sectors.id.toString(),
          })),
        }));
        state.count = count;
      })
      .addCase(getUsers.rejected, (state, { meta }) => {
        if (meta.aborted) {
          state.isLoading = true;
          state.isError = false;
        } else {
          state.isLoading = false;
          state.isError = true;
        }
      });
    builder
      .addCase(createUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createUser.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(createUser.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
    builder
      .addCase(updateUser.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(updateUser.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});
export default userReducer.reducer;
